import React from 'react';
import PropTypes from 'prop-types';
import TimePicker from '@/modules/common/components/TimePicker';
import '../styles/TimeRange.scss';

const TimeRange = (props) => {
    return (
        <div className="time-range">
            <div className="group">
                <TimePicker label={props.label.from}
                            value={props.value.from}
                            onChange={(value) => props.setValue({...props.value, from: value})}
                            error={props.error.from.length > 0}
                            helperText={props.error.from}
                            onFocus={() => props.setError({...props.error, from: ''})}
                            placeholder="00:00"
                />
                <TimePicker label={props.label.to}
                            value={props.value.to}
                            onChange={(value) => props.setValue({...props.value, to: value})}
                            error={props.error.to.length > 0}
                            helperText={props.error.to}
                            onFocus={() => props.setError({...props.error, to: ''})}
                            placeholder="23:59"
                />
            </div>
        </div>
    );
};

TimeRange.propTypes = {
    label: PropTypes.object,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired,
    error: PropTypes.object.isRequired,
    setError: PropTypes.func.isRequired,
};

TimeRange.defaultProps = {
    label: {from: 'с', to: 'по'},
};

export default TimeRange;
